<template>
  <div class="page-header">
    <!-- <img src="../../assets/mikmak-logo-white-new.png" alt="MikMak"> -->
    {{ page }}
  </div>
</template>

<script>
export default {
  props: ['page'],
  mounted() {},
  methods: {},
  computed: {},
  watch: {}
}
</script>

<style scoped>
  .page-header {
    background: rgba(234, 234, 234, 0.28);
    font-family: 'Work Sans', sans-serif;
    text-transform: uppercase;
    color: #afaeae;
    display: block;
    text-align: center;
    font-weight: lighter;
    font-size: 36px;
    padding: 24px;
    padding-top: 100px;
    padding-bottom: 32px;
  }

  @media only screen and (max-width: 800px) {
    .page-header {
      /*padding-top: 0px;*/
    }
  }

  @media only screen and (max-width: 500px) {
    .page-header {
      padding-top: 80px;
    }
  }

  .page-header img {
    display: inline-block;
    width: 85px;
    margin-bottom: -2px;
    margin-right: 6px;
  }
</style>



// WEBPACK FOOTER //
// SubHeader.vue?e0521dc0